import { createSlice } from "@reduxjs/toolkit";

const reducerSlice = createSlice({
  name: "balance",
  initialState: {
    list: [],
    data: {},
    popup: false,
    startDateFilter: "",
    endDateFilter: "",
    currentStatus: 1,
  },
  reducers: {
    setList: (state, action) => {
      state.list = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setPopup: (state, action) => {
      state.popup = action.payload;
    },
    setStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    setEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    setCurrentStatus: (state, action) => {
      state.currentStatus = action.payload;
    },
  },
});

export const {
  setList,
  setPopup,
  setData,
  setStartDateFilter,
  setEndDateFilter,
  setCurrentStatus
} = reducerSlice.actions;

export default reducerSlice;
